import { render, staticRenderFns } from "./select-primary.vue?vue&type=template&id=2907aae7&scoped=true&"
import script from "./select-primary.vue?vue&type=script&lang=js&"
export * from "./select-primary.vue?vue&type=script&lang=js&"
import style0 from "./select-primary.vue?vue&type=style&index=0&id=2907aae7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2907aae7",
  null
  
)

export default component.exports